/*
    Cognigy Endpoint
*/

var endpoint = document.getElementById('cognigy-endpoint');
endpoint.addEventListener('change', function(event) {
    window.customJSON['endpointCognigy']['link'] = event.target.value;

    document.getElementsByClassName("conversation")[0].replaceChildren();

    // INIT TEMPLATE CHATBOT
    function cloneWebchat() {
        var r = document.getElementsByClassName("webchat-root")[0];
        document.getElementsByClassName('conversation')[0].appendChild(r);
    }

    var checkWebchat = setInterval(function(){
        if (document.getElementsByClassName('webchat-root')[0]) {
            if ( document.getElementsByClassName('webchat-root')[0].length != 0 ) {
                cloneWebchat();
                document.getElementsByClassName('webchat-root')[0].style.opacity = 1;        
                clearInterval(checkWebchat);
            }
        }
    })

    initWebchat(event.target.value, {
        settings: {
            colorScheme: '#FFF',
            getStartedText: "",
            startBehavior: 'injection',
            inputPlaceholder: 'Deine Nachricht an mich'
        },
        forceWebsockets: true
    }).then(function(webchat) {
        window.cognigyWebchat = webchat;        
        webchat.open();
    })
})